module.exports = __webpack_public_path__ + "assets/5a60343ad93fc3721cc36cd282d86af1.png";